import { utils, writeFile } from 'xlsx';
import ExcelJS from 'exceljs';
import * as fs from 'file-saver'
export function defaultRelatorioExcel(item: any | null, Controler: string) {

     const fileName = `${Controler}.xlsx`;


     let valoresLimpos = [] as any[]
     if (Controler === "relatorio_parametro") {

          valoresLimpos = item.map((item: any) => ({
               descricao: item.descricao.replace("(MG/L)", "").replace("(ML/L)", "").replace("( °C )", ""),
               qtde: item.qtde,
               qtdeConforme: item.qtdeConforme,
               qtdeNaoConforme: item.qtdeNaoConforme

          }))

     } else if (Controler === "Relatorio_regiao") {

          valoresLimpos = item.map((item: any) => ({
               codigoCliente: item.codigoCliente,
               nome: item.nome,
               nroDocumento: item.nroDocumento,
               status: item.flagAtivo === 1 ? "Habilitado" : "Desabilitado",
               descricaoRamoAtividade: item.descricaoRamoAtividade,
               descricaoRoteiro: item.descricaoRoteiro,
               telefone: item.telefone,
               email: item.email,
               enderecoCompleto: item.enderecoCompleto
          }))
     }
     else if (Controler === "relatorio_AtualizacaoDBO") {

          valoresLimpos = item.map((item: any) => ({
               nome: item.nome,
               dbo: item.dbo,
               endereco: item.endereco,
               uc: item.uc.join("/")
          }))
     }
     else if (Controler === "ponto_coleta") {

          valoresLimpos = item.map((i: any) => ({
               codigoCliente: i.codigo,
               status: i.flagAtivo === 1 ? "Habilitado" : "Desabilitado",
               nome: i.nome,
               pontoColeta: i.descricaoPontoColeta
          }))
     }
     else if (Controler === "Log_usuario") {

          valoresLimpos = item.map((i: any) => ({
               usuario: i.login,
               acao: repararDiv(i.acao),
               data: new Date(i.dtAcao)?.toLocaleString(),
               Extra: i.infoExtra
          }))

          excelToLoger(item)

          return
     }
     else if (Controler === "relatorio_pessoa") {
          valoresLimpos = item.map((item: any) => ({
               status: item.flagAtivo === 1 ? "Habilitado" : "Desabilitado",
               codigoCliente: item.codigoCliente,
               nome: item.nome,
               nroDocumento: item.nroDocumento,
               descricaoRamoAtividade: item.descricaoRamoAtividade,
               descricaoRoteiro: item.descricaoRoteiro,
               telefone: item.telefone,
               email: item.email,
               enderecoCompleto: item.enderecoCompleto
          }))
     }
     else if (Controler === "Relatorio_ranking") {
          valoresLimpos = item.map((item: any) => ({
               'INDÚSTRIA': item.nome,
               'RAMO DE ATIVIDADE': item.ramoAtividade,
               'ESGOTO MENSAL MÉDIO ANO ANTERIOR (m³)': Number(item.volumeEsgoto).toFixed(0),
               "DBO EM DEZEMBRO ANO ANTERIOR (Kg/m³) ": Number(item.dboTotal).toFixed(3).replace(".", ","),
               "CARGA ORGÂNICA DIÁRIA(Kg/DBO)": Number(item.cargaOrganica).toFixed(3).replace(".", ","),
               'MÍNIMO DE COLETAS': item.qtdMin,
               'COLETAS REALIZADAS': item.col,
               'META': item.meta,
               'REGRA DE COLETA': item.regraColeta
          }))
     }
     else {
          valoresLimpos = item
     }




     const worksheet = utils.json_to_sheet(valoresLimpos);


     const workbook = utils.book_new();

     utils.book_append_sheet(workbook, worksheet, Controler)
     writeFile(workbook, fileName)

}

function repararDiv(text: any) {


     text = text.replaceAll("<div class=\"negrito\">", "")
     text = text.replace(/<\/?div.*?>/gi, '')
     text = text.replace(/<br\s*\/?>/gi, '\n')
     text = text.replaceAll("<br/><br/>", "")
     text = text.replaceAll("<div>", "")
     return text.trim();
}


function excelToLoger(dados: any[]) {


     const workbook = new ExcelJS.Workbook();
     const worksheet = workbook.addWorksheet('Planilha');

     // Definição das colunas
     worksheet.columns = [
          { header: 'Usuário', key: 'usuario', width: 20 },
          { header: 'Ação', key: 'acao', width: 50 },
          { header: 'Data', key: 'data', width: 20 },
          { header: 'Extra', key: 'extra', width: 50 },
     ];


     dados.forEach((item) => {
          console.log(item.acao)
          worksheet.addRow({
               usuario: item.login,
               acao: repararDiv(item.acao),
               data: new Date(item.dtAcao).toLocaleString(),
               extra: item.infoExtra,
          });
     });


     worksheet.eachRow((row) => {
          let maxLines = 1;
          row.eachCell((cell) => {
               if (typeof cell.value === 'string') {
                    const lineBreaks = cell.value.split('\n').length;
                    maxLines = Math.max(maxLines, lineBreaks);
                    cell.alignment = { wrapText: true }; // Ativa quebra de texto automática
               }
          });
          row.height = 15 * maxLines; // Ajusta a altura da linha
     });

     workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, `Log_usuario.xlsx`);
     })

}